import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ArrowRight, Gift, ListTree, Target } from 'lucide-react';
import { ToolButton, toolTextSx } from './ToolCard';

export default function SignupCallToAction() {
  return (
    <Box component="aside" aria-labelledby="tools-signup-title" sx={(theme) => ({
      mt: { xs: 5, sm: 6 }, p: { xs: 3, sm: 4, md: 5 }, borderRadius: '32px',
      border: `2px solid ${theme.palette.secondary.main}`,
      background: `linear-gradient(120deg, ${alpha(theme.palette.secondary.main, 0.08)}, ${theme.palette.background.default} 55%, ${alpha(theme.palette.primary.main, 0.08)})`,
      boxShadow: `0 6px 0 ${alpha(theme.palette.secondary.dark, 0.5)}, 0 0 28px ${alpha(theme.palette.secondary.main, 0.1)}`,
      display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'minmax(0, 1.5fr) minmax(0, 1fr)' },
      gap: { xs: 3, md: 5 }, alignItems: 'center',
    })}>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ ...toolTextSx, textAlign: 'center', color: 'secondary.main', mb: 2 }}>Dopatize</Typography>
        <Typography component="h2" id="tools-signup-title" sx={{
          fontSize: { xs: '1rem', sm: '1.3rem' }, lineHeight: 1.9, m: 0, textAlign: 'center',
        }}>Let Dopatize break down and prioritize your to-do list.</Typography>
        <Stack component="ul" gap={1.5} sx={{ listStyle: 'none', p: 0, m: 0, mt: 3 }}>
          {[[ListTree, 'Break tasks into smaller steps'], [Target, 'Automatically prioritize your tasks'], [Gift, 'Earn rewards as you go']].map(([Icon, text]) => (
            <Stack component="li" key={text} direction="row" alignItems="center" gap={1.5}>
              <Icon size={18} aria-hidden="true" style={{ flexShrink: 0 }} />
              <Typography sx={{ ...toolTextSx, color: 'text.primary' }}>{text}</Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
      <Stack alignItems="center" gap={2.5} sx={{ minWidth: 0 }}>
        <ToolButton component={Link} to="/sign-up" variant="contained" fullWidth endIcon={<ArrowRight size={20} aria-hidden="true" />}
          sx={{ minHeight: 60, py: 2, fontSize: { xs: '0.7rem', sm: '0.75rem' } }}>Create an account</ToolButton>
        <Typography sx={{ ...toolTextSx, color: 'text.primary', textAlign: 'center', fontSize: { xs: '0.6rem', sm: '0.65rem' } }}>
          14 days free. No credit card needed.
        </Typography>
      </Stack>
    </Box>
  );
}
